import React from 'react'

function LeftSideLayout1() {
  return <></>
}

export default LeftSideLayout1
